import { h } from 'preact'
import Error from './Error'

export default function BalanceInsufficient() {
  return <Error title="回收数据已达上限，所有评价、问卷中止填写。" code="balance insufficient" />
}
